import { CustomForm } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { AlternativeTranslate, Categories, Departments, Items, ItemsAllergens, ItemsBarcodes, ItemsBomComponents, ItemsChannels, ItemsCombinations, ItemsComponents, ItemsImages, ItemsPrinters, ItemsVariations } from "tilby-models";

interface ItemFieldsFe{
    isNew?:boolean;
}

export type ItemFields = Items & ItemFieldsFe;

export type ItemsFieldsNullable = { [prop in string & keyof ItemFields] : ItemFields[prop] | null }
export type ItemsForm = Partial<CustomForm<ItemsFieldsNullable>>
export class ItemDefault implements ItemFields {
    id?: number | undefined;
    uuid?: string | undefined;
    sku?: string | undefined;
    name!: string;
    alternative_names?: AlternativeTranslate[] | undefined;
    description?: string | undefined;
    alternative_descriptions?: AlternativeTranslate[] | undefined;
    order_name?: string | undefined;
    on_sale?: boolean | undefined;
    is_group_item?: boolean | undefined;
    split_group_components?: boolean | undefined;
    not_discountable?: boolean | undefined;
    index?: number | undefined;
    color?: string | undefined;
    checkout_mark?: boolean | undefined;
    favorite?: boolean | undefined;
    season?: string | undefined;
    brand?: string | undefined;
    code?: string | undefined;
    keyboard_code?: string | undefined;
    price1!: number;
    price2?: number | undefined;
    price3?: number | undefined;
    price4?: number | undefined;
    price5?: number | undefined;
    price6?: number | undefined;
    price7?: number | undefined;
    price8?: number | undefined;
    price9?: number | undefined;
    price10?: number | undefined;
    cost?: number | undefined;
    weight?: number | undefined;
    request_weighing?: boolean | undefined;
    is_frozen?: boolean | undefined;
    vat_perc?: number | undefined;
    option1_value?: string | undefined;
    option2_value?: string | undefined;
    option3_value?: string | undefined;
    option4_value?: string | undefined;
    thumbnail?: string | undefined;
    icon?: string | undefined;
    stock_type?: string | undefined;
    auto_unload?: boolean | undefined;
    manual_production?: boolean | undefined;
    quantity_alert?: number | undefined;
    unit?: string | undefined;
    time_required?: number | undefined;
    created_at?: Date | undefined;
    updated_at?: Date | undefined;
    deleted_at?: Date | undefined;
    department_code?: string | undefined;
    department_id?: number | undefined;
    department2_code?: string | undefined;
    department2_id?: number | undefined;
    department3_code?: string | undefined;
    department3_id?: number | undefined;
    department4_code?: string | undefined;
    department4_id?: number | undefined;
    department5_code?: string | undefined;
    department5_id?: number | undefined;
    department6_code?: string | undefined;
    department6_id?: number | undefined;
    department7_code?: string | undefined;
    department7_id?: number | undefined;
    department8_code?: string | undefined;
    department8_id?: number | undefined;
    department9_code?: string | undefined;
    department9_id?: number | undefined;
    department10_code?: string | undefined;
    department10_id?: number | undefined;
    cache?: string | undefined;
    category_id?: number | undefined;
    category_code?: string | undefined;
    default_supplier_id?: number | undefined;
    net_price?: number | undefined;
    net_price2?: number | undefined;
    net_price3?: number | undefined;
    net_price4?: number | undefined;
    net_price5?: number | undefined;
    net_price6?: number | undefined;
    net_price7?: number | undefined;
    net_price8?: number | undefined;
    net_price9?: number | undefined;
    net_price10?: number | undefined;
    variations?: ItemsVariations[] | undefined;
    components?: ItemsComponents[] | undefined;
    combinations?: ItemsCombinations[] | undefined;
    barcodes?: ItemsBarcodes[] | undefined;
    images?: ItemsImages[] | undefined;
    department?: Departments | undefined;
    department2?: Departments | undefined;
    department3?: Departments | undefined;
    department4?: Departments | undefined;
    department5?: Departments | undefined;
    department6?: Departments | undefined;
    department7?: Departments | undefined;
    department8?: Departments | undefined;
    department9?: Departments | undefined;
    department10?: Departments | undefined;
    category?: Categories | undefined;
    allergens?: ItemsAllergens[] | undefined;
    bom_components?: ItemsBomComponents[] | undefined;
    channels?: ItemsChannels[] | undefined;
    printers?: ItemsPrinters[] | undefined;

    constructor(data?: Partial<Items>) {
        if(data) {
            Object.assign(this, data);

            // this.barcodes = data.barcodes ?? [];
        }
    }
}

export interface ItemsToUpdate {
    uuid: string;
    category_id?: number | null;
    department_id?: number | null;
    department2_id?: number | null;
    department3_id?: number | null;
    department4_id?: number | null;
    department5_id?: number | null;
    department6_id?: number | null;
    department7_id?: number | null;
    department8_id?: number | null;
    department9_id?: number | null;
    department10_id?: number | null;
    price1?: number | null;
    price2?: number | null;
    price3?: number | null;
    price4?: number | null;
    price5?: number | null;
    price6?: number | null;
    price7?: number | null;
    price8?: number | null;
    price9?: number | null;
    price10?: number | null;
    on_sale?: boolean;
    favorite?: boolean;
    color?: string | null;
    request_weighing?: boolean;
    not_discountable?: boolean;
    is_frozen?: boolean;
    checkout_mark?: boolean;
    stock_type?: 'simple' | 'bom' | null;
    auto_unload?: boolean;
}
